import { render, staticRenderFns } from "./MainComponent.vue?vue&type=template&id=f8e45e84&scoped=true"
import script from "./MainComponent.vue?vue&type=script&lang=js"
export * from "./MainComponent.vue?vue&type=script&lang=js"
import style0 from "./MainComponent.vue?vue&type=style&index=0&id=f8e45e84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e45e84",
  null
  
)

export default component.exports